const $ = jQuery;

declare global {
  interface Window {
    FLBuilderLayout: any
  }
}

// required to scroll to anchor links on another page
export function scrollOnLoad() {
  var hash = window.location.hash;

  if ( !window.FLBuilderLayout ) {
    return;
  }

  if ( hash === '' ) {
    return;
  }

  var element = $( hash );

  if ( element.length === 0 ) {
    return;
  }

  setTimeout( function () {
    window.FLBuilderLayout._scrollToElement( element );
  }, 250 );

}
